export const validateBailFields = (filters) => {
  let bailWidth = ({bail_type}) => {
    if (bail_type === 'straight') {
      return 'bail_straight_width_in_mm'
    } else if (bail_type === 'tapered') {
      return 'bail_tapered_width_in_mm'
    }
  }

  const fieldNames = [
    'bail_type',
    'bail_length_in_mm'
  ]

  const fieldErrorMsgMapping = {
    'bail_type': 'bail_type',
    'bail_length_in_mm': 'bail_length',
    'bail_straight_width_in_mm': 'Bail Width (Straight)',
    'bail_tapered_width_in_mm': 'Bail Width (Tapered)'
  }

  if (filters['bail_type']) {
    fieldNames.push(bailWidth(filters))
  }

  let missingFields = fieldNames.filter((e) => { return filters[e] === null })
  return missingFields.map((field) => {
    return fieldErrorMsgMapping[field]
  })
}



// WEBPACK FOOTER //
// ./src/containers/jewelry/validations/bail-fields/index.js